import * as actionTypes from '../actions/actionTypes';
export default function getDarkTitleBarFlagOnPassword(state = {}, action) {
  switch(action.type){
    case actionTypes.SET_DARK_FLAG_PSWD: {
      return action.flag;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/layouts/reducers/getDarkTitleBarFlagOnPassword.js